import React from 'react';
import {toast} from 'react-toastify';

const defaultState = {};

export default messagesHandler => {
	return (state = defaultState, action) => {
		let handler = false;
		let i = 0;
		const size = messagesHandler.length;
		// find the first message handler (see message declaration in ./index.js) then CONSUME it
		// remove the message from state to prevent multiple popup
		while (i < size && handler === false) {
			try {
				handler = messagesHandler[i](action);
			}catch (e) {
				console.error(e);
			}
			i += 1;
		}
		if (handler) {
			const {title, message, type} = handler;

			if (title && message) {
				toast(
					<>
						<h1 className="toaster-title">{title}</h1>
						<p className="toaster-message">{message}</p>
					</>,
					{type}
				);
			} else {
				// provide at least a message or a title
				toast(message || title, {type});
			}
		}
		return {
			...state
		};
	};
};
